export default __webpack_public_path__ + "static/media/invest_boxes.ae4bfc1c.png";